<span [class.error]="isErrorState()">
  {{ 'inventory-op-data.systemState.' + systemState() | translate }}
</span>
